/* global gdAlertify */
import React, { useState, useEffect } from "react";
import axiosInstance from "../config/axiosConfig";
import GdTable from "./components/GdTable";
import { formatDate } from "../utils/utils";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

// Helper to decode JWT locally
const parseJwt = (token) => {
    try {
        return JSON.parse(atob(token.split('.')[1]));
    } catch (e) {
        return null;
    }
};

const ModalNuevaNovedad = ({ isOpen, onClose, onSuccess, novedadEditar }) => {
    const [observacion, setObservacion] = useState("");
    const [fechaDesde, setFechaDesde] = useState(new Date().toISOString().split("T")[0]);
    const [fechaHasta, setFechaHasta] = useState(new Date().toISOString().split("T")[0]);

    useEffect(() => {
        if (isOpen) {
            if (novedadEditar) {
                setObservacion(novedadEditar.observacion || "");
                setFechaDesde(novedadEditar.fecha_desde ? novedadEditar.fecha_desde.split("T")[0] : new Date().toISOString().split("T")[0]);
                setFechaHasta(novedadEditar.fecha_hasta ? novedadEditar.fecha_hasta.split("T")[0] : new Date().toISOString().split("T")[0]);
            } else {
                const hoy = new Date().toISOString().split("T")[0];
                setFechaDesde(hoy);
                setFechaHasta(hoy);
                
                const formatFechaCL = (fechaStr) => {
                    const [y, m, d] = fechaStr.split('-');
                    return `${d}-${m}-${y}`;
                };

                // Inicializar observación con fechas en negrita y plantilla
                setObservacion(`
                    <p><strong>Fecha Desde: ${formatFechaCL(hoy)} - Fecha Hasta: ${formatFechaCL(hoy)}</strong></p>
                    <p><br></p>
                    <p><strong>INGRESOS:</strong></p><p><br></p>
                    <p><strong>CIERRES:</strong></p><p><br></p>
                    <p><strong>PERSONAL DISPONIBLE EN TURNO:</strong></p><p><br></p>
                    <p><strong>PERSONAL DISPONIBLE SIN TURNO:</strong></p><p><br></p>
                    <p><strong>SOLICITAN CAMBIO DE PACIENTES:</strong></p><p><br></p>
                    <p><strong>SISTEMA SK:</strong></p><p><br></p>
                    <p><strong>RADIOTAXIS:</strong></p><p><br></p>
                `);
            }
        }
    }, [isOpen, novedadEditar]);

    // Actualizar observación cuando cambian las fechas (solo al crear)
    useEffect(() => {
        if (isOpen && !novedadEditar) {
            const formatFechaCL = (fechaStr) => {
                if (!fechaStr) return '';
                const [y, m, d] = fechaStr.split('-');
                return `${d}-${m}-${y}`;
            };

             setObservacion(`
                <p><strong>Fecha Desde: ${formatFechaCL(fechaDesde)} - Fecha Hasta: ${formatFechaCL(fechaHasta)}</strong></p>
                <p><br></p>
                <p><strong>INGRESOS:</strong></p><p><br></p>
                <p><strong>CIERRES:</strong></p><p><br></p>
                <p><strong>PERSONAL DISPONIBLE EN TURNO:</strong></p><p><br></p>
                <p><strong>PERSONAL DISPONIBLE SIN TURNO:</strong></p><p><br></p>
                <p><strong>SOLICITAN CAMBIO DE PACIENTES:</strong></p><p><br></p>
                <p><strong>SISTEMA SK:</strong></p><p><br></p>
                <p><strong>RADIOTAXIS:</strong></p><p><br></p>
            `);
        }
    }, [fechaDesde, fechaHasta, isOpen, novedadEditar]);

    const handleGuardar = async () => {
        // Validation: Check if editor is empty or just contains HTML tags
        const strippedContent = observacion.replace(/<[^>]*>/g, '').trim();

        if (!strippedContent) {
            gdAlertify.notify("Debes ingresar una observación.", "error");
            return;
        }

        try {
            gdAlertify.showLoader();
            const payload = {
                fecha: fechaDesde, // Enviar fecha_desde como fecha al servidor
                fecha_desde: fechaDesde,
                fecha_hasta: fechaHasta,
                observacion,
            };

            if (novedadEditar) {
                payload.id = novedadEditar.id;
                await axiosInstance.post("/novedades/guardar", {
                    ...payload,
                    id: novedadEditar ? novedadEditar.id : null
                });
            } else {
                await axiosInstance.post("/novedades/guardar", payload);
            }

            gdAlertify.hideLoader();
            gdAlertify.notify(novedadEditar ? "Novedad actualizada." : "Novedad guardada.", "success");
            onSuccess();
            onClose();
        } catch (error) {
            gdAlertify.hideLoader();
            console.error("Error al guardar novedad: ", error);
            gdAlertify.notify("Error al guardar la novedad.", "error");
        }
    };

    const modules = {
        toolbar: [
            [{ 'header': [1, 2, false] }],
            ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            // [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
            [{ 'align': [] }],
            // ['clean']                                         // remove formatting button (Tx)
            // ['link', 'image', 'video']                        // link and image, video (Adjuntar)
        ]
    };

    if (!isOpen) return null;

    return (
        <>
            <div className="modal fade show" style={{ display: "block" }} tabIndex="-1">
                <div className="modal-dialog modal-xl"> {/* Changed to modal-xl for larger size */}
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{novedadEditar ? "Editar Novedad" : "Nueva Novedad"}</h5>
                            <button type="button" className="btn-close" onClick={onClose}></button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Fecha Desde</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={fechaDesde}
                                        onChange={(e) => setFechaDesde(e.target.value)}
                                    />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Fecha Hasta</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={fechaHasta}
                                        onChange={(e) => setFechaHasta(e.target.value)}
                                    />
                                </div>
                            </div>

                            <div className="mb-3">
                                {/* Removed label "Observación" based on "quites eladjunto el tx" interpretation */}
                                <ReactQuill
                                    theme="snow"
                                    value={observacion}
                                    onChange={setObservacion}
                                    modules={modules}
                                    style={{ height: '300px', marginBottom: '50px' }} // Increased height
                                />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={onClose}>
                                Cancelar
                            </button>
                            <button className="btn btn-primary" onClick={handleGuardar}>
                                Guardar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show"></div>
        </>
    );
};

const Novedades = () => {
    const [data, setData] = useState([]);

    const [modalOpen, setModalOpen] = useState(false);
    const [novedadEditar, setNovedadEditar] = useState(null);
    const [currentUser, setCurrentUser] = useState(null);

    useEffect(() => {
        const token = localStorage.getItem('authToken');
        if (token) {
            const decoded = parseJwt(token);
            if (decoded) {
                // Check multiple possible ID fields
                setCurrentUser(decoded.id || decoded.data?.id || decoded.user_id || decoded.sub);
            }
        }
        fetchNovedades();
    }, []);

    const fetchNovedades = async () => {
        try {
            // Se eliminan los filtros de fecha para traer todas las novedades
            const response = await axiosInstance.get("/novedades/lista");
            if (response.data && response.data.data) {
                setData(response.data.data);
            } else {
                setData([]);
            }
        } catch (error) {
            console.error("Error al buscar novedades: ", error);
        }
    };

    const handleEliminar = (id) => {
        gdAlertify.confirm({
            title: "Eliminar Novedad",
            message: "¿Estás seguro de que deseas eliminar esta novedad?",
            onConfirm: async () => {
                try {
                    gdAlertify.showLoader();
                    await axiosInstance.post("/novedades/eliminar", { id });
                    gdAlertify.hideLoader();
                    gdAlertify.notify("Novedad eliminada.", "success");
                    fetchNovedades();
                } catch (error) {
                    gdAlertify.hideLoader();
                    console.error("Error al eliminar novedad: ", error);
                    gdAlertify.notify("Error al eliminar.", "error");
                }
            },
            onCancel: () => { },
        });
    };

    const openModalEditar = (novedad) => {
        setNovedadEditar(novedad);
        setModalOpen(true);
    };

    const openModalNuevo = () => {
        setNovedadEditar(null);
        setModalOpen(true);
    };

    const columns = [
        { name: "id", title: "#", width: 50 },
        {
            name: "usuario",
            title: "Creado por",
            render: (row) => row.usuario || row.nombre_usuario || "N/A",
            width: 150
        },
        {
            name: "observacion",
            title: "Observación",
            render: (row) => {
                const fechaDesdeStr = row.fecha_desde ? new Date(row.fecha_desde).toLocaleDateString('es-CL') : '';
                const fechaHastaStr = row.fecha_hasta ? new Date(row.fecha_hasta).toLocaleDateString('es-CL') : '';
                const fechasHTML = (fechaDesdeStr && fechaHastaStr)
                    ? `<p><strong>Fecha Desde: ${fechaDesdeStr} - Fecha Hasta: ${fechaHastaStr}</strong></p>`
                    : '';

                return (
                    <div dangerouslySetInnerHTML={{ __html: fechasHTML + (row.observacion || '') }} />
                );
            }
        },
        {
            name: "acciones",
            title: "Acciones",
            render: (row) => {
                const isOwner = currentUser && (parseInt(currentUser) === parseInt(row.usuario_id));
                return (
                    <div className="d-flex gap-2">
                        {isOwner && (
                            <>
                                <button
                                    className="btn btn-warning btn-sm text-white"
                                    onClick={() => openModalEditar(row)}
                                    title="Editar"
                                >
                                    <i className="bi bi-pencil"></i>
                                </button>
                                <button
                                    className="btn btn-danger btn-sm"
                                    onClick={() => handleEliminar(row.id)}
                                    title="Eliminar"
                                >
                                    <i className="bi bi-trash"></i>
                                </button>
                            </>
                        )}
                    </div>
                );
            },
            width: 120,
        },
    ];

    return (
        <div className="container mt-5">
            <div className="card p-4">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h3>Novedades Coordinación</h3>
                    <button className="btn btn-primary" onClick={openModalNuevo}>
                        Nueva Novedad
                    </button>
                </div>

                <GdTable
                    columns={columns}
                    data={data}
                    defaultItemsPerPage={25}
                    itemsPerPageOptions={[10, 25, 50, 100]}
                    initialSort={[0, "desc"]}
                />
            </div>

            <ModalNuevaNovedad
                isOpen={modalOpen}
                onClose={() => setModalOpen(false)}
                onSuccess={fetchNovedades}
                novedadEditar={novedadEditar}
            />
        </div>
    );
};

export default Novedades;
